import { IAppState, TActions } from '../../common/state';
import { jq } from '../../json_query';

export function promoSearchTypesReducer(state: IAppState, action: TActions): IAppState {
  const jsonQuery = jq(state.filters.jsonQuery);

  switch (action.type) {
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'promo_search_types') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jsonQuery.unsetPromoSearchTypes(action.tag.value),
          },
        };
      }

      return state;

    default:
      return state;
  }
}
